import React from 'react'
import { useSelector } from 'react-redux'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import './calendar-enhancements.scss'
import moment from 'moment'
require('moment/locale/es.js')
const localizer = momentLocalizer(moment)

const CalendarComponent = ({ myEventsList, onSelectEvent, onSelectSlot }) => {

  const userProfile = useSelector((state) => state.userProfile || {})

  return (
    <div className='calendar-container' style={{ position: 'relative' }}>
      <div
        className='calendar-legend'
        style={{
          display: 'flex',
          gap: '20px',
          marginBottom: '10px',
          alignItems: 'center',
          fontSize: '14px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <div
            style={{
              width: '16px',
              height: '16px',
              backgroundColor: '#ED8B00',
              borderRadius: '3px',
            }}
          ></div>
          <span style={{ color: '#737372' }}>Eventos</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <div
            style={{
              width: '16px',
              height: '16px',
              backgroundColor: '#00a499',
              borderRadius: '3px',
            }}
          ></div>
          <span style={{ color: '#737372' }}>Leads/Tareas</span>
        </div>
      </div>
      <span className='calendar-help-text'>
        Haz clic en un elemento para editarlo (tareas) o verlo (eventos), o en
        un día vacío para crear una nueva tarea
      </span>
      <Calendar
        popup
        selectable // Permitir seleccionar slots de tiempo
        localizer={localizer}
        events={myEventsList}
        startAccessor='start'
        endAccessor='end'
        style={{ height: 690 }}
        views={{
          month: true,
          week: true,
          day: true,
        }}
        messages={{
          next: '>',
          previous: '<',
          today: 'Hoy',
          month: 'Mes',
          week: 'Semana',
          day: 'Día',
          allDay: 'Todo el día',
          date: 'Fecha',
          time: 'Hora',
          event: 'Evento',
          showMore: (total) => `+ Ver más (${total})`,
        }}
        onSelectEvent={onSelectEvent} // Manejar clic en evento existente
        onSelectSlot={onSelectSlot} // Manejar clic en slot vacío
        eventPropGetter={(event) => {
          
          const isEvent = event.type === 'event'

          console.log("eventPropGetter event", event.resource.isVerCaledario)

          return {
            style: {
              backgroundColor: isEvent ? '#ED8B00' : '#00a499', // Azul para eventos, verde para tasks
              borderColor: isEvent ? '#ED8B00' : '#00a499',
              color: 'white',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '500',
              opacity: (userProfile.roles.codigo != 1000)
                ? 1
                : (event?.resource?.isVerCaledario ? 1 : 0.4),
              display: (userProfile.roles.codigo != 1000)
                ? (event?.resource?.isVerCaledario ? 'block' : 'none')
                : 'block',
            },
          }
        }}
        slotPropGetter={(date) => ({
          style: {
            cursor: 'pointer',
          },
        })}
        /* establecemos un hour range */
        // min={
        //     new Date(0, 0, 0, 6, 0, 0)
        // }

        // max={
        //     new Date(0, 0, 0, 0, 0, 0)
        // }
      />
    </div>
  )
}

export default CalendarComponent
